import { ITradeItem } from '../../../models';
import { IClassicPlayerConfig } from './classic-player-config.interface';

export interface IClassicWinnerConfig extends IClassicPlayerConfig {
  ticketNumber: number | null;
  winnerWeapon?: ITradeItem | null;
}
